// example importing other Bootstrap Javascript Module
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab'
import Collapse from 'bootstrap/js/dist/collapse';

// custom library
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


function checkNavbarScrolled() {
    const navbarPrimaryEl = document.querySelector('.custom-navbar')
    const navbarSecondaryEl = document.querySelector('.custom-navbar--secondary')

    if (navbarPrimaryEl) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbarPrimaryEl.classList.add('scroll')
            } else {
                navbarPrimaryEl.classList.remove('scroll')
            }
    
            if (window.scrollY > 600) {
                navbarPrimaryEl.classList.add('scrolled')
                document.querySelector('.custom-navbar__buttons a').className = 'themeBtn'
            } else {
                navbarPrimaryEl.classList.remove('scrolled')
                document.querySelector('.custom-navbar__buttons a').className = 'themeBtn--white'
            }
        })
    }

    if (navbarSecondaryEl) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbarSecondaryEl.classList.add('scroll')
            } else {
                navbarSecondaryEl.classList.remove('scroll')
            }
        })
    }
}

function menuSelectionNavbar() {
    const navbarMenuImage = document.querySelectorAll('.top-offcanvas__image-container img')
    const triggerTabList = document.querySelectorAll('.top-offcanvas__type .menu-link')

    triggerTabList.forEach(triggerEl => {
        const tabTrigger = new Tab(triggerEl)

        triggerEl.addEventListener('mouseenter', event => {
            event.preventDefault()
            tabTrigger.show()

            navbarMenuImage.forEach(nmi => {
                nmi.setAttribute('src', event.target.dataset.image)
            });
        })

        triggerEl.addEventListener('click', event => {
            window.location.href = event.target.href
        })
    })
}

function menuParentTab() {
    const triggerTabList = document.querySelectorAll('.navbar-location-inner .menu-item span')
    triggerTabList.forEach(triggerEl => {

        const tabTrigger = new Tab(triggerEl)

        // console.log(tabTrigger);

        triggerEl.addEventListener('mouseenter', event => {
            event.preventDefault()
            tabTrigger.show()
        })
    })
}

function setActiveTabInsideOffcanvas() {
    const triggerTabParent = document.querySelectorAll('.navbar-location-parent .menu-item span')

    triggerTabParent.forEach(parentBtnTab => {
        parentBtnTab.addEventListener('click', () => {
            const target = parentBtnTab.getAttribute('data-custom-tab')

            const triggerEl = document.querySelector('.navbar-location-inner .menu-item span[data-bs-target="' + target +'"]')

            Tab.getInstance(triggerEl).show()
        })
    });
}

function triggerAuthModal() {
    const urlQuery = window.location.search.slice(1) // GET QUERY URL
    const loginModal = new Modal('#loginModal')

    if (urlQuery == 'login') {
        loginModal.show()
    }
}

function hidePageTransition() {
    gsap.to('.page-transition', {
        duration: 0.3,
        autoAlpha: 0,
    })
}

document.addEventListener('DOMContentLoaded', () => {
    checkNavbarScrolled()
    menuSelectionNavbar()
    menuParentTab()
    triggerAuthModal()
    setActiveTabInsideOffcanvas()
    hidePageTransition()
})

export { gsap, ScrollTrigger }